import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ChatbotController() {
  const { pathname } = useLocation()

  useEffect(() => {
    const allowedRoutes = ['/', '/educator-landing']
    const scriptId = 'chatbot-script'
    const scriptLoadedFlag = 'noupeChatbotLoaded'

    const isScriptExecuted = () => {
      return (
        window[scriptLoadedFlag] ||
        typeof window.jfAgentCacheName !== 'undefined'
      )
    }

    const hideChatbotWidget = () => {
      const chatbotSelectors = [
        '[id*="chatbot"]',
        '[id*="noupe"]',
        '[class*="chatbot"]',
        '[class*="noupe"]',
        'iframe[src*="noupe"]',
        'iframe[src*="chatbot"]'
      ]

      chatbotSelectors.forEach((selector) => {
        try {
          const elements = document.querySelectorAll(selector)
          elements.forEach((el) => {
            if (el && el.parentNode) {
              el.style.display = 'none'
            }
          })
        } catch (error) {
          console.warn(
            `Error hiding chatbot element with selector ${selector}:`,
            error
          )
        }
      })

      const allIframes = document.querySelectorAll('iframe')
      allIframes.forEach((iframe) => {
        const src = iframe.getAttribute('src') || ''
        if (src.includes('noupe.com') || src.includes('chatbot')) {
          iframe.style.display = 'none'
        }
      })
    }

    const showChatbotWidget = () => {
      const chatbotSelectors = [
        '[id*="chatbot"]',
        '[id*="noupe"]',
        '[class*="chatbot"]',
        '[class*="noupe"]',
        'iframe[src*="noupe"]',
        'iframe[src*="chatbot"]'
      ]

      chatbotSelectors.forEach((selector) => {
        try {
          const elements = document.querySelectorAll(selector)
          elements.forEach((el) => {
            if (el && el.parentNode) {
              el.style.display = ''
            }
          })
        } catch (error) {
          console.warn(
            `Error showing chatbot element with selector ${selector}:`,
            error
          )
        }
      })

      const allIframes = document.querySelectorAll('iframe')
      allIframes.forEach((iframe) => {
        const src = iframe.getAttribute('src') || ''
        if (src.includes('noupe.com') || src.includes('chatbot')) {
          iframe.style.display = ''
        }
      })
    }

    const removeChatbotWidget = () => {
      const chatbotSelectors = [
        '[id*="chatbot"]',
        '[id*="noupe"]',
        '[class*="chatbot"]',
        '[class*="noupe"]',
        'iframe[src*="noupe"]',
        'iframe[src*="chatbot"]'
      ]

      chatbotSelectors.forEach((selector) => {
        try {
          const elements = document.querySelectorAll(selector)
          elements.forEach((el) => {
            if (el && el.parentNode) {
              el.remove()
            }
          })
        } catch (error) {
          console.warn(
            `Error removing chatbot element with selector ${selector}:`,
            error
          )
        }
      })

      const allIframes = document.querySelectorAll('iframe')
      allIframes.forEach((iframe) => {
        const src = iframe.getAttribute('src') || ''
        if (src.includes('noupe.com') || src.includes('chatbot')) {
          iframe.remove()
        }
      })
    }

    let observer = null

    if (allowedRoutes.includes(pathname)) {
      const existingScript = document.getElementById(scriptId)
      const hasWidget = document.querySelector(
        '[id*="chatbot"], [id*="noupe"], [class*="chatbot"], [class*="noupe"], iframe[src*="noupe"]'
      )

      if (isScriptExecuted()) {
        showChatbotWidget()
      } else if (!existingScript) {
        const script = document.createElement('script')
        script.src =
          'https://www.noupe.com/embed/019b731a2ab87dd7865532104c503077cefe.js'
        script.async = true
        script.id = scriptId
        script.onload = () => {
          window[scriptLoadedFlag] = true
        }
        document.body.appendChild(script)
      } else if (!hasWidget) {
        showChatbotWidget()
      }
    } else {
      if (isScriptExecuted()) {
        hideChatbotWidget()

        observer = new MutationObserver(() => {
          hideChatbotWidget()
        })

        observer.observe(document.body, {
          childList: true,
          subtree: true
        })
      } else {
        removeChatbotWidget()

        observer = new MutationObserver(() => {
          removeChatbotWidget()
        })

        observer.observe(document.body, {
          childList: true,
          subtree: true
        })
      }
    }

    return () => {
      if (observer) {
        observer.disconnect()
      }
    }
  }, [pathname])

  return null
}
